/**
 * A helper class for managing user tags.
 */
export default class UserTagHelper {
  static userTag = null;

  /**
   * Sets the user tag to the specified value.
   * @param {any} value - The value to set as the user tag.
   */
  static setUserTag(value) {
    UserTagHelper.userTag = value;
  }

  /**
   * Gets the current user tag.
   * @returns {any} The current user tag, or null if not set.
   */
  static getUserTag() {
    return UserTagHelper.userTag || null;
  }

  /**
   * Clears the current user tag.
   */
  static clearUserTag() {
    UserTagHelper.userTag = null;
  }
}
